import { render, staticRenderFns } from "./loginAsIdcard.vue?vue&type=template&id=076cd07e"
import script from "./loginAsIdcard.vue?vue&type=script&lang=js"
export * from "./loginAsIdcard.vue?vue&type=script&lang=js"
import style0 from "./loginAsIdcard.vue?vue&type=style&index=0&id=076cd07e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports